// setGiftPanel.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

const selectPath = ['gift', 'panel'];
/**
 * Set gift panel
 * @kind action
 * @param {boolean} { isOpen } - open state for gift panel.
 * @param {boolean} { isSwiping } - swiping state for gift panel.
 * @return {Promise} Action promise.
 */
const setGiftPanel =
  ({ isOpen, isSwiping }) =>
  async dispatch => {
    let data = {};

    if (isOpen != null) {
      data.isGiftPanelOpen = isOpen;
    }

    if (isSwiping != null) {
      data.isSwiping = isSwiping;
    }

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: { selectPath, data },
    });
  };

export default setGiftPanel;
